import React from 'react';
import { CATS, GOLD, GOLD_HI, pctLabel } from './agendaStore';
import { Panel } from './AgendaCharts';

const Th = ({ children, w }) => (
  <th className="font-['Cinzel'] uppercase font-normal py-1.5" style={{ width: w, fontSize: 8.5, letterSpacing: '0.12em', color: GOLD_HI }}>{children}</th>
);

const Bar = ({ pct, color }) => (
  <div className="h-3 rounded-sm overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
    <div className="h-full rounded-sm" style={{ width: `${pct * 100}%`, background: `linear-gradient(90deg, ${color}, ${GOLD_HI})`, transition: 'width 0.3s ease-out' }}/>
  </div>
);

export const AgendaAnalysis = ({ perItem }) => (
  <Panel title="Analysis" testid="agenda-analysis">
    <table className="w-full font-['Outfit'] tabular-nums" style={{ borderCollapse: 'collapse' }}>
      <thead style={{ background: '#140f06' }}>
        <tr><Th>Item</Th><Th w={34}>Goal</Th><Th w={40}>Actual</Th><Th w={32}>Left</Th><Th>Progress</Th><Th w={38}>%</Th></tr>
      </thead>
      <tbody>
        {perItem.map(({ item, goal, actual, left, pct }) => {
          const cat = CATS[item.cat] || CATS.fashion;
          return (
            <tr key={item.id} data-testid={`agenda-analysis-row-${item.id}`} style={{ borderTop: '1px solid rgba(212,175,55,0.1)' }}>
              <td className="pl-2 py-1.5">
                <span className="flex items-center gap-1 min-w-0">
                  <img src={cat.icon} alt="" className="w-3.5 h-3.5 object-contain flex-shrink-0"/>
                  <span className="truncate text-white" style={{ fontSize: 10, maxWidth: 70 }}>{item.name}</span>
                </span>
              </td>
              <td className="text-center" style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>{goal}</td>
              <td className="text-center" style={{ fontSize: 11, color: '#fff', fontWeight: 600 }}>{actual}</td>
              <td className="text-center" style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)' }}>{left}</td>
              <td className="px-1"><Bar pct={pct} color={cat.color}/></td>
              <td className="text-center pr-1" style={{ fontSize: 11, color: GOLD_HI }}>{pctLabel(pct)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </Panel>
);

export const TopHabits = ({ perItem }) => {
  const top = [...perItem].sort((a, b) => b.pct - a.pct || b.actual - a.actual).slice(0, 10);
  return (
    <Panel title="Top 10 Habits" testid="agenda-top10">
      <div className="px-3 py-2 flex flex-col gap-1.5">
        {top.map(({ item, pct }, i) => {
          const cat = CATS[item.cat] || CATS.fashion;
          return (
            <div key={item.id} className="flex items-center gap-2" data-testid={`agenda-top-${i + 1}`}>
              <span className="w-5 text-center font-['Cinzel']" style={{ color: i < 3 ? GOLD_HI : 'rgba(255,255,255,0.5)', fontSize: 12 }}>{i + 1}</span>
              <span className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: `${cat.color}26`, border: `1px solid ${cat.color}` }}>
                <img src={cat.icon} alt="" className="w-4 h-4 object-contain"/>
              </span>
              <span className="flex-1 truncate font-['Outfit'] text-white" style={{ fontSize: 12 }}>{item.name}</span>
              <span className="w-16"><Bar pct={pct} color={cat.color}/></span>
              <span className="w-9 text-right font-['Outfit'] tabular-nums" style={{ fontSize: 11, color: GOLD }}>{pctLabel(pct)}</span>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};
